import { Grid2, Box, Typography } from "@mui/material"
import background from "../../../ui-utils/photos/bgvideo.mp4"
import Styles from "./Mob.module.css"
import Sunil from "../../../ui-utils/latestPics/Sunil.jpg"
import Laxmi from "../../../ui-utils/latestPics/Laxmi.jpg"
import Anil from "../../../ui-utils/latestPics/Anil.jpg"
import en from "../../../i18n/English/Aboutus/department.json";
import hi from "../../../i18n/Hindi/Aboutus/department.json";
import kn from "../../../i18n/Kannada/Aboutus/department.json";
import ma from "../../../i18n/Marathi/Aboutus/department.json";
import gu from "../../../i18n/Gujarati/Aboutus/department.json";
import { useLanguage } from "../../../Context/LangContext";
import { useState } from "react"
export default function Mobile() {

    const [isFlipped, setIsFlipped] = useState(false);
    const [isFlipped2, setIsFlipped2] = useState(false);
    const [isFlipped3, setIsFlipped3] = useState(false);

    const handleTouchFlip = () => {
        setIsFlipped((prev) => !prev);
    };

    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language] || translations.en;
    return (
        <>
            <Box className={Styles.HomeSectionBox}>

                <Grid2 sx={{ width: "100%" }}>

                    <div className={Styles.headingContainer}>
                        <div className={Styles.gradientBackground}></div>
                        <Typography className={Styles.leader_title} style={{ fontWeight: 600 }}>
                            {t.title}
                        </Typography>
                    </div>

                    <Grid2 className={Styles.inner_card}>
                        {/* <Grid2  className={Styles.leader_card1}>

                                    <Typography className={Styles.ex_subtit}>Mr. Narayana B. Shetty</Typography>
                                    <Typography className={Styles.ex_subtit1}>MD &amp; Chiarman</Typography>
                                    <Typography className={Styles.ex_subtit2}>Mr. Shetty is a seasoned professional,
                                        possessing over more than four decades of
                                        experience in the Indian Stock Market as well
                                        as Financial Markets.</Typography>

                                </Grid2> */}
                        <Grid2
                            className={`${Styles.flip_card} ${isFlipped ? Styles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped(!isFlipped)}
                        >
                            <Grid2 className={Styles.flip_card}>
                                <Grid2 className={Styles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={Styles.flip_card_front}>
                                        <img src={Sunil} alt="leaderpic" className={Styles.picture} />
                                        <Typography className={Styles.ex_subtit}>{t.members[0].name}</Typography>
                                        <Typography className={Styles.ex_subtit1}>{t.members[0].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={Styles.flip_card_back}>
                                        <Typography className={Styles.ex_subtit}>{t.members[0].name}</Typography>
                                        <Typography className={Styles.ex_subtit1}>{t.members[0].designation}</Typography>
                                        <Typography className={Styles.ex_subtit2}>
                                            <span className={Styles.span} style={{ fontWeight: 600 }}>{t.members[0].name}</span>{t.members[0].description}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Grid2
                            className={`${Styles.flip_card} ${isFlipped2 ? Styles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped2(!isFlipped2)}
                        >

                            <Grid2 className={Styles.flip_card} sx={{ marginTop: "42px" }}>
                                <Grid2 className={Styles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={Styles.flip_card_front}>
                                        <img src={Anil} alt="leaderpic" className={Styles.picture} />
                                        <Typography className={Styles.ex_subtit}>{t.members[1].name}</Typography>
                                        <Typography className={Styles.ex_subtit1}>{t.members[1].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={Styles.flip_card_back}>
                                        <Typography className={Styles.ex_subtit}>{t.members[1].name}</Typography>
                                        <Typography className={Styles.ex_subtit1}>{t.members[1].designation}</Typography>
                                        <Typography className={Styles.ex_subtit2}>

                                            <span className={Styles.span} style={{ fontWeight: 600 }}>{t.members[1].name}</span>{t.members[1].description}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                        </Grid2>

                        <Grid2
                            className={`${Styles.flip_card} ${isFlipped3 ? Styles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped3(!isFlipped3)}
                            sx={{ marginTop: "82px" }}
                        >
                            <Grid2 className={Styles.flip_card} >
                                <Grid2 className={Styles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={Styles.flip_card_front}>
                                        <img src={Laxmi} alt="leaderpic" className={Styles.picture} />
                                        <Typography className={Styles.ex_subtit}>{t.members[2].name}</Typography>
                                        <Typography className={Styles.ex_subtit1}>{t.members[2].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={Styles.flip_card_back}>
                                        <Typography className={Styles.ex_subtit}>{t.members[2].name}</Typography>
                                        <Typography className={Styles.ex_subtit1}>{t.members[2].designation}</Typography>
                                        <Typography className={Styles.ex_subtit2}>
                                            <span className={Styles.span} style={{ fontWeight: 600 }}>{t.members[2].name}</span>{t.members[2].description}
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                    </Grid2>

                </Grid2>
            </Box>
        </>
    )
}